// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-date-range-selector .ant-picker-time-panel {\n  display: none!important;\n  } ", "",{"version":3,"sources":["webpack://./src/components/DateTimeSelectors/DateRangeSelector/DateRangeSelector.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB","sourcesContent":[".custom-date-range-selector .ant-picker-time-panel {\n  display: none!important;\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
